import session from './session';

Storage.prototype.setObject = function(key, value) {
    this.setItem(key, JSON.stringify(value));
}

Storage.prototype.getObject = function(key) {
    return JSON.parse(this.getItem(key));
}

const REQUEST_STORAGE_KEY = 'REQUEST_STORAGE_KEY';

export default {
  login(username, password) {
    return session.post('/auth/login/', { username, password });
  },
  logout() {
    return session.post('/auth/logout/', {});
  },
  createAccount(payload) {
    return session.post('/auth/registration/', payload);
  },
  changeAccountPassword(new_password1, new_password2) {
    return session.post('/auth/password/change/', { new_password1, new_password2 });
  },
  sendAccountPasswordResetEmail(email, recaptcha) {
    return session.post('/auth/password/reset/', { email, recaptcha });
  },
  resetAccountPassword(uid, token, new_password1, new_password2) { // eslint-disable-line camelcase
    return session.post('/auth/password/reset/confirm/', { uid, token, new_password1, new_password2 });
  },
  getAccountDetails() {
    return session.get('/v1/users/me/');
  },
  getSocialAccounts() {
    return session.get('/v1/users/me/social/');
  },
  updateAccountDetails(data) {
    return session.patch('/v1/users/me/', data);
  },
  socialDisconnect(pk){
    return session.post('/auth/social/'+pk+'/disconnect/');
  },
  verifyAccountEmail(key) {
    return session.post('/auth/registration/verify-email/', { key });
  },
  dumpRequestResponse(data) {
    return localStorage.setObject(REQUEST_STORAGE_KEY, data);
  },
  getRequestResponse() {
    let data = localStorage.getObject(REQUEST_STORAGE_KEY);
    localStorage.removeItem(REQUEST_STORAGE_KEY);
    return data;
  },
};
